import React from 'react';

import Article from 'grommet/components/Article';
import Header from 'grommet/components/Header';
import Anchor from 'grommet/components/Anchor';
import Title from 'grommet/components/Title';
import Box from 'grommet/components/Box';
import Button from 'grommet/components/Button';
import Heading from 'grommet/components/Heading';
import Footer from 'grommet/components/Footer';
import Login from 'grommet/components/icons/base/Login';

import './styles.scss';

export default function() {
  return (
    <div>
      <Header
        justify="between"
        size="small"
        colorIndex="brand"
        pad={{horizontal: 'small'}}>
        <Title>MRTN Survey</Title>
        <Anchor path="/login" icon={<Login />} label="Staff" />
      </Header>
      <Article align="center" pad="medium">
        <Box size="xlarge" align="center">
          <Header size="large" direction="column" pad={{between: 'large'}}>
            <Box direction="row" pad={{between: 'large'}} flex={false} align="center">
              <img alt="ISA Research" src="/images/research.png"/>
              <img alt="Integrated Farm Livestock Management" src="/images/IFLM.jpg"/>
            </Box>
            <Box>
              <Button path="/entry" label="Click here to access the form" />
            </Box>
          </Header>
          <Box direction="row" pad={{ vertical: 'large', between: 'large' }}>
            <Box>
              <ol>
                <li>Enter general field information.</li>
                <li>Enter the standard Nitrogen management you used.</li>
                <li>Enter the MRTN recommended Nitrogen management you used as described here: <Anchor href="http://cnrc.agron.iastate.edu" target="_blank">cnrc.agron.iastate.edu</Anchor>.</li>
                <li>Enter yield for replications with your applied standard Nitrogen.</li>
                <li>Enter yield for replications with the MRTN recommended applied Nitrogen.</li>
                <li>Click Submit. It may take a few seconds for the data to transfer. You will receive a confirmation message when complete.</li>
              </ol>
              <Heading tag="h3" strong><em>Thank you for your participation!</em></Heading>
            </Box>
            <Box align="center" pad={{horizontal: 'medium'}}>
              <img alt="Plot layout sample" src="/images/map.png" className="assessment"/>
            </Box>
          </Box>
          <Footer wrap align="center" justify="between">
            <img src="/images/on-farm.png" alt="On-Farm Network"/>
            <img src="/images/eps.png" alt="Environmental Programs & Services"/>
            <img src="/images/analytics.png" alt="ISA Analytics"/>
          </Footer>
        </Box>
      </Article>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Landing/index.js